import {
  GET_ADMIN_DASHBOARD_REQUEST,
  GET_ADMIN_DASHBOARD_SUCCESS,
  GET_ADMIN_DASHBOARD_FAILURE,
  CLEAR_DASHBOARD_DATA
} from '../../constants/dashboard/dashboardConstants';

export const getAdminDashboardRequest = () => ({
  type: GET_ADMIN_DASHBOARD_REQUEST
});

export const getAdminDashboardSuccess = (data) => ({
  type: GET_ADMIN_DASHBOARD_SUCCESS,
  payload: data
});

export const getAdminDashboardFailure = (error) => ({
  type: GET_ADMIN_DASHBOARD_FAILURE,
  payload: error
});

export const clearDashboardData = () => ({
  type: CLEAR_DASHBOARD_DATA
});

export const fetchAdminDashboard = (oemId, scanType) => ({
  type: 'FETCH_ADMIN_DASHBOARD_SAGA',
  payload: { oemId, scanType }
});